{
    "confirm": {
        "confirmToDeleteMediaAndRemoveFromProjects": "Удалить и убрать из проекта | Удалить и убрать из проектов ",
        "unsavedChanges": "Несохраненные изменения!",
        "areYouSureYouWantToRemovePage": "Удалить '{pageName}'.",
        "deleteStyle": "Удалить стиль?",
        "deleteMedia": "Удалить медиа?",
        "deleteMediaImplications": "Удалить и убрать из проектов?",
        "deletePlayer": "Удалить плеер?",
        "deletePlayerImplications": "Это действие приведет к удалению плеера из вашей учетной записи ARYA и к удалению всех настроек, связанных с этим плеером, включая расписание.",
        "permanentlyDeleteTheUserAccount": "Удалить учетную запись.",
        "removeTemplate": "Удалить шаблон",
        "removeTemplateDesc": "Вы хотите удалить этот шаблон из данного стиля?",
        "removeTheMediaFromTheSchedule": "Удалить из расписания.",
        "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "Удалить медиа.",
        "mediaUsedInProject": "Медиа, используемые в проекте | Медиа, используемые в проектах",
        "confirmPassword": "Подтвердите пароль",
        "changeEmail": "Изменить электронную почту",
        "deleteOrder": "Удалить заказ",
        "deleteTag": "Удалить тег?",
        "deletePopId": "Удалить PoP ID?",
        "deleteUser": "Удалить пользователя?",
        "deleteAccount": "Удалить учетную запись?",
        "leaveAccount": "Покинуть аккаунт?",
        "deleteCanvasResolution": "Удалить разрешение холста?",
        "downloadLicense": "Скачать лицензию?",
        "cancelOrder": "Отменить заказ?",
        "removeAccessFromArya": "Удалить доступ из ARYA?",
        "deleteTemplate": "Удалить шаблон?"
    },
    "signinup": {
        "new": "Нет регистрации в {productNameShort}?",
        "newUser": "Новый пользователь"
    },
    "label": {
        "aryaAccountID": "Идентификатор учетной записи Arya",
        "accountId": "Идентификатор учетной записи",
        "admin": "админ",
        "addPlayer": "Добавить плеер",
        "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "Код {code} уже используется для другой учетной записи.",
        "assignCodeHasAlreadyBeenAssignedErrorMessage": "Код {code} уже был присвоен.",
        "account": "Учетная запись | Учетные записи",
        "accountInfo": "Информация об учетной записи",
        "accountInformation": "Информация об учетной записи",
        "accountName": "Название учетной записи",
        "accountPlan": "План учетной записи",
        "accountCorrespondent": "Корреспондент учетной записи",
        "accountIsDeleted": "Учетная запись была удалена",
        "activate": "активировать",
        "address": "адрес",
        "alert": "оповещение | оповещения",
        "amount": "количество",
        "apply": "применить ",
        "assign": "назначение | назначения",
        "audio": "аудио",
        "auto": "авто",
        "basic": "базовый",
        "bannerText1": "Плановое обслуживание",
        "bannerText2": "{date} г. в {time} будет проходить плановое техническое обслуживание, которое продлится примерно {approximateHours} ч. Извините за доставленные неудобства в течение этого времени.",
        "bannerText3": "Во время технического обслуживания в {productName} нельзя будет изменять контент, но плееры продолжат отображать свой контент.",
        "billing": "Выставление счетов",
        "billingDetails": "Платежная информация",
        "buy": "купить",
        "comment": "примечание",
        "companyInformation": "Информация о компании",
        "contentNotSupported": "контент не поддерживается, нажмите для получения дополнительной информации...",
        "copy": "копия | копии",
        "configPending": "Конфигурация обрабатывается",
        "configError": "Ошибка конфигурации",
        "credentials": "учетные данные",
        "credentialsNotValid": "Учетные данные недействительны",
        "createStyle": "Создать стиль",
        "createUserExistErrorMessage": "{email} уже связан с этой учетной записью.",
        "createUserLimitReached": "Достигнут лимит пользователей",
        "creditCard": "Кредитная карта",
        "download": "Скачать",
        "extended": "расширенный",
        "expirationDate": "Дата окончания срока действия",
        "expires": "истекает",
        "keyboardShortcuts": "Горячие клавиши",
        "language": "Язык",
        "learnMore": "дополнительная информация",
        "leaveAccount": "Покинуть учетную запись",
        "leaveAccountWithOnlyOneUserMessage": "Вы не можете покинуть учетную запись, так как являетесь ее единственным пользователем.",
        "leaveAccountTheOnlyAdminInTheAccountMessage": "Вы не можете покинуть учетную запись, так как являетесь ее единственным администратором.",
        "leaveAccountImplicationsCommonMessage": "Это действие приведет к удалению вас из данной учетной записи.",
        "license": "лицензия",
        "limited": "ограниченный",
        "location": "Местонахождение",
        "login": "Войти",
        "loginError": "Что-то пошло не так. Мы не можем войти в систему в данный момент. Повторите попытку позже или обратитесь к администратору.",
        "loginWith": "Войти с помощью",
        "loginString2": "Контент сразу на экране. Свободно.",
        "loginString3": "Простота работы с информационными табло.",
        "loginString4": "Заказывайте и активируйте наборы функций без проблем",
        "loginOKStringTitle2": "Простота работы с Smart Sync.",
        "loginOKStringDesc1": "Настройте его. Составьте расписание. Расставьте приоритеты.",
        "loginOKStringDesc2": "Добавьте к нему теги. Используйте интеллектуальную синхронизацию. При необходимости настройте оповещения.",
        "loginOKString4": "Следующий шаг. Быстрая настройка плеера.",
        "loginOKString5": "Все, что вам нужно, это серийный номер вашего плеера.",
        "loginOKQuotaWarnMain": "Свободное хранилище заполнено на {percentage}%.",
        "loginOKQuotaWarnSub": "Обновите систему до {plan} и получите полностью настраиваемые шаблоны и оповещения, 10 ГБ памяти на плеер, 10 пользователей, теги, интеллектуальную синхронизацию тегов и многое другое.",
        "loginOKQuotaReachedMain": "Свободное хранилище заполнено на {percentage}%.",
        "loginOKQuotaReachedSub": "Обновите систему до {plan} и получите полностью настраиваемые шаблоны и оповещения, 10 ГБ памяти на плеер, 10 пользователей, теги, интеллектуальную синхронизацию тегов и многое другое.",
        "loginOKQuotaExcededMain": "Свободное хранилище полностью заполнено.",
        "loginOKQuotaExcededSub": "Обновите систему до {plan} и получите полностью настраиваемые шаблоны и оповещения, 10 ГБ памяти на плеер, 10 пользователей, теги, интеллектуальную синхронизацию тегов и многое другое.",
        "logoutOKStringTitle1": "ВЫ ВЫШЛИ ИЗ УЧЕТНОЙ ЗАПИСИ",
        "logoutOKStringDesc1": "Вы можете войти снова, нажав кнопку ниже.",
        "notice": "уведомление",
        "playerSetupString1": "Создайте свой проект.",
        "playerSetupString2": "Это супер просто. Это супер быстро.",
        "playerSetupString3": "",
        "payments": "платежи",
        "pageNotFound": "Извините, страница не найдена",
        "plan": "план | планы",
        "popIdentifier": "ИДЕНТИФИКАТОР PoP",
        "postalCode": "Почтовый индекс",
        "purchasePlanUpgradeSuccessMain": "Добро пожаловать в {plan}",
        "purchasePlanDowngradeSuccessMain": "План учетной записи был понижен до {planName}",
        "loggedOffInFewSeconds": "Выход будет сделан через несколько секунд",
        "termsOfServiceString1": "Условия обслуживания",
        "termsOfServiceString2": "Последнее обновление: 9 января 2019 г.",
        "termsOfServiceString3": "Загрузите и прочтите следующий документ",
        "termsOfServiceString4": "УСЛОВИЯ ОБСЛУЖИВАНИЯ",
        "termsOfServiceString5": "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ",
        "termsOfServiceString6": "Выберите ПРИНЯТЬ, чтобы продолжить.",
        "accept": "принять",
        "all": "Все",
        "allPlayers": "Все плееры",
        "add": "Добавить",
        "setPassword": "Подтвердить",
        "support": "поддержка",
        "cancel": "удалить",
        "canvasSize": "Размер холста: {size} (в пикселях)",
        "canvasExistsError": "Холст с таким размером уже существует",
        "cardType": "тип карты",
        "cardNumber": "номер карты",
        "change": "изменить",
        "clickToEdit": "Редактировать",
        "city": "город",
        "color": "цвет | цвета",
        "company": "компания",
        "companyName": "Название компании",
        "confirm": "Подтвердить",
        "confirmation": "Подтверждение",
        "warning": "Внимание!",
        "codeIsRequired": "Требуется код подтверждения",
        "code": "Код",
        "contact": "контакт",
        "country": "страна",
        "create": "Создать",
        "checkThePlayer": "Подключиться к Интернету. Подключить питание.",
        "checkDetails": "Проверить детали",
        "chooseHorizontalOrVerticalScreenOrientations": "Выберите ориентацию экрана",
        "continue": "Продолжить",
        "conctactSystemAdmin": "Пожалуйста, свяжитесь с вашим системным администратором.",
        "custom": "настроить",
        "customerInfo": "Информация о пользователе",
        "date": "дата",
        "dropFilesHere": "Перетащите файлы сюда",
        "deactivate": "дезактивировать",
        "default": "по умолчанию",
        "delete": "удалить",
        "deleteAccount": "удалить учетную запись",
        "deleteUser": "удалить пользователя",
        "deleteOnAllPlayers": "УДАЛИТЬ на ВСЕХ ПЛЕЕРАХ.",
        "deleteFromSchedule": "Удалить из расписания",
        "demoVersion": "Демо-версия",
        "disable": "отключить",
        "disabled": "отключено",
        "distributor": "дистрибьютор",
        "downgradeAccount": "Изменить план учетной записи на более низкий",
        "downgradeTo": "Изменить план на {plan}",
        "duplicate": "Дублировать",
        "duplicateFile": "Дублировать файл",
        "duplicateInSchedule": "Дублировать в расписание",
        "duration": "Длительность",
        "adsDuration": "Длительность рекламы",
        "error": "ошибка",
        "email": "Электронная почта",
        "emailAlreadyExists": "Этот адрес электронной почты уже используется другим пользователем. Используйте другой адрес. ",
        "enable": "включить",
        "enabled": "включено",
        "endDate": "Конец",
        "endTime": "Конец",
        "end": "закончить",
        "edit": "Редактировать",
        "editProject": "Редактировать проект",
        "feedbackForm": "Дать обратную связь",
        "firstName": "Имя",
        "firmwareUpdate": "ОБНОВЛЕНИЕ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ",
        "failed": "Обратитесь в техподдержку",
        "file": "Файл | Файлы",
        "forgotPassword": "Забыли пароль?",
        "formatNotSupported": "Файлы '{format}' не поддерживаются.",
        "firmware": "Программное обеспечение",
        "freeVersion": "Бесплатная версия",
        "freeVersionNA": "Бесплатная версия недоступна",
        "get": "получить",
        "getCode": "Получить конфигурацию",
        "getConfig": "Получить конфигурацию",
        "generateNewAPIKey": "Сгенерировать новый ключ API",
        "generateUserAPIKeyWarningMessage": "Это действие сделает предыдущий ключ API недействительным, все существующие соединения с API необходимо будет перенастроить на использование нового ключа API.",
        "goBack": "Назад",
        "goToLogin": "Перейти ко входу",
        "helpCenter": "Центр поддержки",
        "horizontalView": "Горизонтальный вид",
        "image": "Изображение | Изображения",
        "implications": "последствия",
        "implicationsDeleteTag": "Это действие удалит данный тег из всех {deleteFrom}. Это может повлиять на разрешения пользователя и расписание.",
        "implicationsDeleteLedTag": "Это действие удалит данный тег из всех плееров.  Любой плеер, имевший этот тег, необходимо будет заново настроить, чтобы снова опубликовать на нем содержимое с таким разрешением.",
        "implicationsDeletePopId": "Это действие удалит данный идентификатор PoP везде, где он используется.",
        "importantToNote": "Важные примечания",
        "logo": "логотип",
        "userProfile": "Профиль пользователя",
        "userSignOut": "Выйти",
        "userNotConfirmed": "Пользователь не подтвержден",
        "userNotFound": "Пользователь не существует. Убедитесь, что учетная запись существует",
        "userManagement": "Управление пользователями",
        "id": "id",
        "incorrectUsername": "Неверный адрес электронной почты",
        "incorrectPassword": "Неверный пароль",
        "installedOrCapacity": "Установлено / Вместимость",
        "installed": "Установлено",
        "installedOrCapacityUnlimitedMaxValue": "безлимитных плееров",
        "invalidEmail": "Недействительный адрес электронной почты",
        "invalidPassword": "Недействительный пароль",
        "invalidUserdata": "Обратитесь в техподдержку",
        "invalidSerialNumber": "Неправильный серийный номер",
        "invalidDSOSTypeAmount": "Недействительное значение. Введите число.",
        "invalidResolution": "Неверное разрешение",
        "invoice": "счет-фактура | счета-фактуры",
        "inviteUser": "Пригласить пользователя",
        "requiredDeviceName": "Введите имя",
        "regular": "регулярный",
        "resetPassword": "Восстановить пароль",
        "loading": "Загрузка...",
        "lastName": "Фамилия",
        "lastLogin": "Последний вход в учетную запись",
        "modify": "изменить",
        "monitoring": "мониторинг",
        "newPassword": "Новый пароль",
        "newPasswordRequiredWarning": "Установить новый пароль",
        "confirmNewPassword": "Подтвердить новый пароль",
        "new": "Новый",
        "newCanvas": "Новый холст",
        "newProject": "новый проект",
        "newEmail": "Новый адрес электронной почты",
        "newResolution": "Новое разрешение",
        "name": "имя",
        "naText": "N/A",
        "next": "след.",
        "nextRenewalDate": "Следующее обновление: {renewalDate}",
        "noVideoAvailable": "Видео недоступно.",
        "noEmailProvided": "Не указан адрес электронной почты",
        "none": "отсутствует",
        "noSearchResults": "нет результатов",
        "noPermissionToAccessThePage": "Отказано в доступе",
        "noPlayersInstalled": "Не установлены плееры",
        "noPlayerGroupsAvailable": "Нет доступных групп плееров",
        "notConfigured": "Требуется настройка",
        "nameYourPlayerEGReception": "Назовите свой плеер, например «Получение»",
        "ok": "ок",
        "or": "или",
        "orders": "заказы",
        "order": "заказ | заказы",
        "offline": "Офлайн",
        "online": "онлайн",
        "options": "варианты",
        "page": "Страница",
        "player": "плеер | плееры",
        "playerName": "Имя плеера",
        "playerModel": "Модель плеера",
        "playerGroups": "Группы плееров",
        "pleaseEnterACity": "Введите город",
        "pin": "PIN-код",
        "pinShownOnYourScreen": "PIN-код показан на экране",
        "playTime": "Время проигрывания",
        "PleaseTryAgainOrHeadBackToTheHomepage": "Попробуйте еще раз или вернитесь на домашнюю страницу.",
        "playerIsNotConnectedToTheCloud": "Неправильный серийный номер",
        "pleaseTryAgain": "Попробуйте еще раз",
        "pleaseEnterThePin": "Требуется PIN-код",
        "pleaseEnterValidPin": "Введите 4 или 6 цифр, которые отображаются на экране",
        "pinMustBeFourDigitNumber": "PIN-код должен включать от 4 до 6 цифр",
        "pinMustBeAtleastOneThousand": "PIN-код должен быть не менее 1000",
        "pleaseCheckYourEmailForVerificationCode": "Код подтверждения был отправлен на ваш адрес электронной почты",
        "password": "пароль",
        "passwordDidNotMatch": "Пароль не совпадает",
        "passwordCannotBeReset": "Пароль не может быть сброшен",
        "passwordHasBeenChanged": "Ваш пароль был изменен",
        "passwordAttemptLimitExceeded": "Превышен лимит попыток. Попробуйте еще раз через некоторое время.",
        "passwordPolicyRequirementText": "Пароль должен состоять из 8 или более символов, включать прописные, строчные, цифровые и специальные символы.",
        "price": "Цена",
        "priceSlashMonth": "Цена / Месяц",
        "priority": "приоритет",
        "privacy": "Конфиденциальность",
        "project": "Проект | Проекты",
        "projectName": "Название проекта",
        "profile": "Профиль",
        "proofOfPlay": "Доказательство воспроизведения",
        "preview": "Предпросмотр",
        "previewUnavailable": "Предпросмотр недоступен",
        "proceed": "продолжить ",
        "publishTo": "Опубликовать в",
        "releaseNotes": "Информация о версии",
        "remove": "удалить",
        "removeUserFromAccount": "удалить пользователя из учетной записи",
        "replace": "заменить",
        "reporting": "отчетность",
        "reset": "переустановить",
        "restart": "начать сначала",
        "resolution": "разрешение",
        "reactivate": "реактивировать",
        "resetPasswordDescription": "Введите адрес электронной почты, чтобы получить код подтверждения",
        "resetPasswordCodeSent": "Код подтверждения был отправлен на ваш адрес электронной почты",
        "resetPasswordCodeSentIfAccountExist": "ЕСЛИ УЧЕТНАЯ ЗАПИСЬ СУЩЕСТВУЕТ",
        "requiredAccountName": "Введите имя учетной записи",
        "requiredEmail": "Введите адрес электронной почты",
        "requiredCountry": "Введите название страны",
        "requiredPassword": "Введите пароль",
        "requiredConfirmPassword": "Подтвердите пароль",
        "requiredFirstName": "Введите имя",
        "requiredLastName": "Введите фамилию",
        "requiredName": "Введите имя",
        "requiredUsername": "Введите адрес электронной почты",
        "requiredVerificationCode": "Введите код подтверждения",
        "requiredSerialNumber": "Введите серийный номер ",
        "requiredCity": "Введите город",
        "requiredState": "Введите название страны",
        "requiredZipOrPostalCode": "Введите почтовый индекс",
        "requiredStreetAndNumber": "Введите улицу и номер дома",
        "requiredCompanyName": "Введите название компании",
        "requiredDataStorageRegion": "Требуется регион хранения данных",
        "invalidDataStorageRegion": "Недопустимый регион хранения данных",
        "review": "проверить",
        "signOut": "выйти",
        "search": "Поиск",
        "addressSearchPlaceholder": "Введите адрес, чтобы найти плееры",
        "searching": "идет поиск",
        "status": "статус",
        "save": "сохранить",
        "reconfigure": "Перезапуск настройки",
        "saveAs": "Сохранить как",
        "saveChanges": "Сохранить изменения",
        "savedStyles": "Сохраненные стили",
        "schedule": "запланировать",
        "scheduledToTag": "Запланировано добавить тег",
        "screen": "экран",
        "screenOn": "Включить экран",
        "screenOrientation": "Ориентация экрана",
        "security": "Безопасность",
        "sendCode": "Отправить код",
        "sendEmail": "Отправить",
        "sendInvitation": "Отправить приглашение",
        "sendTo": "Отправить кому",
        "serial": "Серийный номер",
        "serialNumber": "Серийный номер",
        "serialNumberAlreadyAssigned": "Серийный номер уже присвоен",
        "select": "ВЫБРАТЬ",
        "selectAll": "выбрать все",
        "selectLanguage": "выбрать язык",
        "setup": "Настроить",
        "settings": "настройки",
        "shapeColors": "Цвета формы",
        "shareWithText": "Информационное табло «{productShortName}». Просто Умно. Мощно.",
        "signIn": "Войти",
        "signUp": "Зарегистрироваться",
        "signUpErrorMessageAccountEmailExist": "Учетная запись с указанным электронным адресом уже существует.",
        "slowSync": "SLOW SYNC ",
        "sorry": "Извините.",
        "streetAndNumber": "Улица и номер дома",
        "success": "успешно завершено",
        "summary": "краткое содержание",
        "somethingWentWrong": "Что-то пошло не так",
        "song": "Пеня | Песни",
        "startDate": "Начальная дата",
        "startTime": "Начать",
        "start": "Начать",
        "state": "страна",
        "steps": "этапы",
        "styleName": "Название стиля",
        "storage": "хранилище",
        "subtotal": "Промежуточный итог",
        "subscription": "подписка",
        "subscriptionMonthlyAutoRenew": "Ежемесячно (автопродление)",
        "ssoLoginErrorTitle": "Что-то пошло не так. Мы не можем войти в систему в данный момент. Повторите попытку позже или обратитесь к администратору.",
        "ssoMigrateAccountStep1Title1": "Учетная запись, связанная с {email}, уже существует.",
        "ssoMigrateAccountStep1Title2": "Вы можете переключить его на использование SSO {provider}.",
        "ssoMigrateAccountStep1Title3": "Приступить к подтверждению переключения.",
        "ssoMigrateAccountStep2Title1": "После перехода на SSO {provider}",
        "ssoMigrateAccountStep2Title2": "ваше предыдущее подключение больше не будет работать.",
        "ssoMigrateAccountStep2Title3": "Это действие не может быть отменено.",
        "ssoMigrateAccountVerifyTitle1": "Мы должны проверить вашу учетную запись {email}.",
        "ssoMigrateAccountVerifyTitle2": "Пожалуйста, войдите в эту учетную запись, чтобы продолжить.",
        "tag": "тег | теги",
        "defaultTags": "Теги по умолчанию",
        "text": "текст",
        "deleteAccountWithMultipleUsersMessage": "Перед тем, как удалить эту учетную запись, необходимо удалить всех остальных пользователей.",
        "deleteAccountWithDistributorRightsMessage": "Эта учетная запись не может быть удалена. Она управляется дистрибьютором.",
        "deleteAccountTitleThisActionWill": "Это действие приведет к",
        "deleteAccountImplications": {
            "deleteAccount": "1. Удалению учетной записи",
            "deleteUser": "2. Удалению пользователя"
        },
        "youCannotDeleteUserAsOnlyUserInAccount": "Вы не можете удалить пользователя, так как являетесь единственным пользователем этой учетной записи.",
        "timeZone": "Часовой пояс",
        "time": "Время",
        "timeShorthandSecond": "с",
        "timeShorthandMinute": "мин",
        "timeShorthandHour": "ч",
        "template": "Шаблон | Шаблоны",
        "temporaryPassword": "временный пароль",
        "tempPasswordExpiredPleaseContactAdmin": "Срок действия временного пароля истек. Свяжитесь со своим администратором",
        "total": "итого",
        "tutorial": "Руководство пользователя | Руководства пользователя",
        "user": "пользователь | пользователи",
        "userAPIKey": "Ключ API",
        "userNotActive": "Пользователь не активен",
        "usernameShouldBeValidEmail": "Имя пользователя – это действительный адрес электронной почты",
        "updatedAccountInfo": "Информация о вашей учетной записи была обновлена.",
        "updatedCustomerInfo": "Информация о вашем клиенте была обновлена.",
        "updatedProfile": "Ваш профиль пользователя был обновлен.",
        "updated": "обновлено",
        "upload": "Загрузить",
        "upTime": "время работы",
        "upgrade": "обновить",
        "video": "Видео",
        "vat": "НДС",
        "verificationCode": "Код подтверждения",
        "verticalView": "Вертикальный вид",
        "withResolution": "с разрешением {resolution}",
        "yourPlan": "ваш план",
        "youHaveLeftAccount": "Вы покинули учетную запись",
        "zipOrPostalCode": "ZIP",
        "mon": "пн",
        "tue": "вт",
        "wed": "ср",
        "thu": "чт",
        "fri": "пт",
        "sat": "сб",
        "sun": "вс",
        "apps": "приложения",
        "multiplePopIdsNotAllowed": "Каждый файл может иметь только один идентификатор подтверждения воспроизведения.",
        "forbidden": "Что-то пошло не так, и мы не смогли выполнить ваш запрос. Вы будете перенаправлены на главную страницу в ближайшее время.",
        "dataStorageRegion": "Регион хранения данных",
        "verificationSentToEmailIfExist": "Код подтверждения отправлен на вашу электронную почту (если аккаунт существует)",
        "alreadyHaveAnAccountRedirect": "Уже есть аккаунт? {linkStart}Войти{linkEnd}",
        "emailText": "Электронная почта",
        "passwordText": "Пароль",
        "signupWith": "Зарегистрироваться через",
        "setNewPassword": "Установить пароль",
        "passwordHint": "{minStart}Минимум 8 символов,{minEnd} {upStart}заглавная буква,{upEnd} {lowStart}строчная буква,{lowEnd} {numStart}цифра{numEnd}{numSpecialSeparatorStart} и {numSpecialSeparatorEnd}{spStart}специальный символ{spEnd}.",
        "home": "Главная",
        "loginWithName": "Войти через {name}",
        "signupWithName": "Зарегистрироваться через {name}",
        "fileType": "Тип файла",
        "lastModified": "Последнее изменение",
        "images": "Изображения",
        "videos": "Видео",
        "projectsOrPdf": "Проекты / PDF",
        "elementiProject": "Проекты Elementi",
        "scheduled": "Запланировано",
        "notScheduled": "Не запланировано",
        "from": "С",
        "to": "По",
        "fileTypes": "Типы файлов",
        "contentStatus": "Статус контента",
        "modifiedDate": "Дата изменения",
        "filters": "Фильтры",
        "sortBy": "Сортировать по",
        "sort": "Сортировка",
        "lastModifiedDesc": "Последнее изменение (сначала новые)",
        "lastModifiedAsc": "Последнее изменение (сначала старые)",
        "nameAsc": "Название (А → Я)",
        "nameDesc": "Название (Я → А)",
        "grid": "Сетка",
        "canvas": "Холст",
        "audioPlaylist": "Аудиоплейлист",
        "isAlertActive": "Alert активен",
        "active": "Активный",
        "inactive": "Неактивный",
        "filesPage": "Страница файлов",
        "ledPage": "Страница LED",
        "videowallPage": "Страница Videowall",
        "alertPage": "Страница оповещений"
    },
    "buttons": {
        "backToProduct": "Назад к {productName}",
        "reload": "Перезагрузить",
        "previous": "Предыдущий",
        "next": "Далее",
        "loadMore": "Загрузить ещё",
        "addNewUser": "Добавить нового пользователя",
        "apply": "Применить",
        "clearAll": "Очистить всё",
        "reset": "Сбросить",
        "tryItNow": "Попробовать сейчас",
        "switchBack": "Вернуться назад",
        "cancel": "Отмена",
        "deleteMedia": "Удалить медиа",
        "deletePlayer": "Удалить плеер",
        "deleteTag": "Удалить тег",
        "deletePopId": "Удалить PoP ID",
        "deleteUser": "Удалить пользователя",
        "continueWithoutSaving": "Продолжить без сохранения",
        "close": "Закрыть",
        "cancelOrder": "Отменить заказ",
        "removeUser": "Удалить пользователя",
        "deleteTemplate": "Удалить шаблон",
        "deleteStyle": "Удалить стиль",
        "ok": "ОК",
        "delete": "Удалить",
        "keepBoth": "Оставить оба",
        "replaceExistingFile": "Заменить существующий файл",
        "replaceExistingFiles": "Заменить существующие файлы"
    },
    "texts": {
        "youAreLoggingIn": "Вход с електронной почтой",
        "productAccessDisabled": "У вас нет доступа к {product}",
        "productAccessDisabledWarning": "У вас нет доступа к {product} для аккаунта {account}.\n\nВам либо не был предоставлен доступ к этому продукту, либо ваш доступ был отозван Глобальным администратором. Пожалуйста, свяжитесь с Глобальным администратором для получения дополнительной информации или запроса доступа.\n\nВы можете продолжать использовать другие продукты, к которым у вас есть разрешение в этом аккаунте.",
        "tablePageCountWTotal": "Показано {min}{separator}{max} из {total}",
        "tablePageCountWoutTotal": "Показано {min}{separator}{max}",
        "dataStorageRegionHint": "Выберите регион, где будут храниться данные вашего аккаунта. Это решение должно соответствовать местным законам о защите данных и требованиям соответствия. Обратите внимание: после выбора регион размещения данных нельзя изменить позже.",
        "welcomeToHUB": "Добро пожаловать в SpinetiX HUB!",
        "welcomeToHUBDesc": "SpinetiX HUB — это ваша универсальная онлайн-платформа для управления всем, что связано с вашими цифровыми вывесками SpinetiX в облаке.",
        "hubGlobalAdmin": "Глобальный администратор SpinetiX",
        "hubGlobalAdminDesc": "Этот пользователь является глобальным администратором в HUB, что автоматически предоставляет ему роль администратора в ARYA. Это назначение роли нельзя изменить.",
        "removeAccessFromAryaTitle": "Удалить доступ к ARYA?",
        "removeAccessFromAryaMessage": "Это действие удалит доступ пользователя {userName} только к ARYA.",
        "removeAccessFromAryaByNonGlobalAdmin": "Чтобы удалить пользователя из учетной записи HUB, обратитесь к вашему Global Admin.",
        "removeAccessFromAryaByGlobalAdmin": "Они сохранят доступ к другим продуктам в этой учетной записи HUB.\n\nЧтобы удалить пользователя из учетной записи HUB, перейдите на {link}",
        "hubUserManagement": "Управление пользователями HUB",
        "goToHUBUserManagement": "перейдите в управление пользователями HUB.",
        "noContentHasBeenScheduledYet": "Контент ещё не запланирован.",
        "emptyFilterTablePlaceholder": "Нам не удалось найти элементы, соответствующие вашему запросу. Попробуйте изменить условия поиска и повторите попытку!",
        "requestId": "ID запроса:",
        "externalSignInMessage": "Вы вошли в систему через внешнего поставщика идентификации (например, Google, Facebook или SSO с другим поставщиком). Ваши учетные данные, включая {email} и {password}, управляются этим провайдером.",
        "youHaveUnsavedChanges": "У вас есть несохранённые изменения.",
        "waitForUploadingFile": "Файл загружается, подождите...",
        "defaultTagsNote": "Проекты наследуют теги пакета стилей при создании из шаблона. Если впоследствии вы добавите или удалите теги из пакета стилей, существующие проекты обновлены не будут.",
        "seeAll": "Показать все",
        "allPlayTimes": "Все времена воспроизведения"
    },
    "switchedAccount": {
        "title": "Ваш браузер не поддерживается",
        "desc1": "Добро пожаловать обратно!",
        "switch": "переключить",
        "text1": "Учетная запись переключена",
        "text2": "на {account}"
    },
    "unsupportedBrowser": {
        "bannerTitle": "Ваш браузер не поддерживается.",
        "bannerMessage": "Вы используете неподдерживаемый браузер. Некоторые функции могут работать некорректно. Для лучшей работы с нашим продуктом поменяйте браузер на {highlightStart}Google Chrome{highlightEnd} или {highlightStart}Microsoft Edge{highlightEnd}."
    },
    "plans": {
        "downgradedToFreeDesc": "План {plan} теперь включен. Последнее списание с вашей кредитной карты пройдет в конце платежного цикла",
        "free": "Бесплатно",
        "tags": "Интеллектуальное синхронизирование и теги",
        "sharedStorage": "общее хранилище",
        "custom": "Пользовательские настройки и оповещения",
        "playerStorage": "Хранилище плеера",
        "playerPerMonth": "плеер / месяц | плееры / месяц",
        "review": {
            "termsAndConditionsMain": "Размещая свой заказ, вы соглашаетесь с",
            "termsAndConditionsSub": "условиями продажи SpinetiX"
        }
    },
    "filters": {
        "images": "изображения",
        "videos": "видео",
        "audio": "аудио",
        "projectsOrPdf": "проекты / PDF",
        "scheduled": "запланировано",
        "elementiProject": "проекты elementi"
    },
    "template": {
        "24H": "24Ч",
        "AM/PM": "AM/PM",
        "addPage": "Добавить страницу",
        "arrowSettings": "Настройки стрелок",
        "back": "Назад",
        "background": "Фон",
        "both": "Оба",
        "bottom": "дно",
        "center": "центр",
        "cellSettings": "Настройки ячейки",
        "clock": "часы",
        "clockSettings": "Настройки часов",
        "countdown": "Отсчёт",
        "countdownSettings": "Настройки отсчета",
        "custom": "настроить",
        "changeMedia": "Изменить медиа",
        "default": "по умолчанию",
        "duplicatePage": "дублировать страницу",
        "date": "дата",
        "days": "дни",
        "effects": "Эффекты",
        "fade": "Прозрачность",
        "fill": "заполнить",
        "front": "Лицевая сторона",
        "frameFitting": "Посадка рамки",
        "hours": "часы",
        "imageEffects": "Эффекты изображения",
        "kenBurns": "Эффект Кена Бернса",
        "noEffect": "Без эффектов",
        "noBorder": "Без границ",
        "noMargin": "Без отступов",
        "L": "L",
        "large": "большой",
        "left": "Слева",
        "local": "местный",
        "long": "длинный\r\n",
        "M": "М",
        "meet": "встретить",
        "media": "медиафайл",
        "menu": "меню",
        "mediatable": "таблица медиафайлов",
        "middle": "Средний",
        "month": "месяц",
        "overlay": "наложение",
        "overview": "обзор",
        "playOnce": "Воспроизвести один раз",
        "qr": "QR",
        "reg": "запись",
        "repeat": "повтор",
        "right": "Справа",
        "rss": "RSS",
        "shape": "форма",
        "shapeSettings": "Настройки формы",
        "shapeSettingsHint": "Подсказка: Начните печатать, чтобы добавить текст",
        "slice": "нарезка",
        "slide": "Слайд",
        "small": "маленький",
        "smart": "умный",
        "S": "S",
        "time": "Время",
        "timeAndDate": "ВРЕМЯ + ДАТА",
        "tableSettings": "Настройки таблицы",
        "text": "текст",
        "textSettings": "Настройки текста",
        "top": "верх",
        "wayfinding": "поиск пути",
        "weather": "погода",
        "html": "веб-страница",
        "url": "url",
        "videoin": "Видео-вход",
        "videoWidth": "ширина видео",
        "videoHeight": "высота видео",
        "videoSettings": "Настройки видео",
        "frameRate": "частота кадров",
        "frameWidth": "Выбрать ширину",
        "format": "формат",
        "error": {
            "invalidLink": "Неверная ссылка"
        },
        "placeholder": {
            "url": "Введите URL-адрес"
        },
        "weatherIconSettings": "Настройки значка погоды",
        "weatherLocationSettings": "Настройки места погоды",
        "weatherLocationSettingsHint": "Подсказка: Тип названия местности",
        "webpageSettings": "Настройки веб-страницы",
        "qrSettings": "Настройки QR-кода",
        "rssSettings": "Настройки RSS",
        "rssSettingsTooltip": "RSS-каналы, предлагаемые {productName}, поступают от <b>сторонних провайдеров</b>.<br/>Мы стараемся предоставить разнообразный выбор каналов, чтобы удовлетворить ваши потребности, однако их качество и производительность полностью зависят от сторонних поставщиков.",
        "stream": "Стрим",
        "list": "Список"
    },
    "templates": {
        "duration": "Длительность",
        "pageDuration": "Длительность страницы",
        "timezone": "Часовой пояс",
        "tags": "Теги",
        "playtimes": "Время проигрывания",
        "alignElements": "Выравнивание элементов",
        "removeTemplateConfirmation": "Вы уверены, что хотите удалить этот шаблон из стиля \"{styleName}\"?",
        "deleteStyleConfirmation": "Вы уверены, что хотите удалить стиль \"{styleName}\"?",
        "deleteStyleWarning": "Удалив этот стиль, вы удалите все шаблоны, созданные в нём.",
        "noTemplatesAvailable": "Нет доступных шаблонов",
        "noStylePackAccess": "В настоящее время у вас нет доступа к пакетам стилей, содержащим шаблоны. Пакеты стилей доступны только при условии предоставления доступа через назначенные вам разрешения или теги.\nЕсли вы считаете, что должны иметь доступ, обратитесь к администратору вашей учётной записи."
    },
    "Hours": {
        "title": "Название",
        "time": "Часы",
        "media": "Медиа"
    },
    "Info": {
        "info": "Информация",
        "title": "Название",
        "description": "Текст",
        "media": "Медиа"
    },
    "Logo": {
        "title": "Текст"
    },
    "Menu": {
        "menu": "Меню",
        "title": "Текст",
        "price": "Цена",
        "media": "Медиа"
    },
    "News": {
        "news": "Новости",
        "title": "Текст",
        "timezone": "Часовой пояс",
        "format": "Формат",
        "media": "Медиа"
    },
    "Person": {
        "person": "Человек",
        "title": "Верхняя граница текста",
        "description": "Нижняя граница текста",
        "media": "Медиа"
    },
    "Product": {
        "product": "Продукт",
        "title": "Текст",
        "price": "Цена",
        "media": "Медиа"
    },
    "RSS": {
        "rss-news": "RSS Новости",
        "rss": "RSS",
        "news": "Новости"
    },
    "Weather": {
        "weather": "Погода",
        "locations": "Город",
        "display": "Отображение",
        "media": "Медиа"
    },
    "playerSetup": {
        "navConfirm": "Подтвердить",
        "navFinish": "Завершить",
        "navNext": "Вперед",
        "navPrev": "Назад",
        "navCancel": "Удалить",
        "addPlayerToPlan": "Добавить плеер в ваш тарифный план",
        "currentPlan": "Текущий план",
        "canvasName": "Название холста",
        "canvasVideoNote": "Вы найдете свой новый холст в {canvasType} под этим именем.",
        "canvasVideoNoteType_led": "Секция LED",
        "canvasVideoNoteType_videowall": "Секция видеостены",
        "canvasSize": "Размер холста",
        "canvasSizeFormatted": "{canvasSize} (в пикселях)",
        "updateTo": "Обновить до",
        "numberOfPlayers": "Количество плееров",
        "dialogTitle": "Настройка плеера",
        "onlyDigitsRequired": "Вводите только цифры",
        "serialNumberRequired": "Серийный номер не может быть пустым",
        "incorrectSerialNumber": "Пожалуйста, введите правильный серийный номер",
        "incorrectSerialNumberCharacters": "Ошибка ввода. В этом поле можно вводить только английские буквы и цифры.",
        "incorrectInput": "Неправильный ввод",
        "playerName": "Название",
        "playerNamePlaceholder": "Имя медиаплеера",
        "requiredPlayerName": "Имя медиаплеера обязательно",
        "requiredScreenDiagonal": "Введите диагональ экрана",
        "requiredHorizontalBezel": "Введите горизонтальную рамку/отступ",
        "requiredVerticalBezel": "Введите вертикальную рамку/отступ",
        "playerTimezoneHint": "Выберите часовой пояс медиаплеера",
        "Progress_PIN": "PIN-код",
        "Progress_Name": "Имя и часовой пояс",
        "Progress_DisplaySettings": "Настройки отображения",
        "Progress_Application": "Приложение",
        "Progress_Arrangement": "Расположение",
        "Progress_Adjustments": "Корректировки",
        "DisplayOrientation": "Ориентация экрана",
        "DisplayResolution": "Разрешение экрана",
        "DisplayResolutionHint": "Выберите разрешение экрана",
        "Application": "Приложение",
        "ApplicationSingleDisplay": "Одиночный дисплей",
        "ApplicationMirroring": "Зеркальное отображение",
        "ApplicationVideowall": "Видеостена",
        "ApplicationAvailable": "* Доступно с",
        "ApplicationAvailbleWithNote": "*Доступно с\r\n",
        "screenDiagonal": "Диагональ экрана",
        "SelectApplication": "Выберите приложение",
        "SelectDisplayOrientation": "Выберите ориентацию дисплея",
        "SelectNumberOfDisplays": "Выберите количество дисплеев",
        "standardScreenOnly": "Только стандартный экран (9:16 и 16:9)",
        "OrientationAndResolution": "Настройки ориентации и разрешения будут применяться ко всем дисплеям",
        "DisplaysArrangement": "Расположение дисплея",
        "SelectDisplayArrangement": "Выберите расположение дисплея",
        "HorizontalBezel": "Горизонтальная рамка/отступ",
        "VerticalBezel": "Вертикальная рамка/отступ",
        "OutputResolutions": "Выходные данные разрешения",
        "CannotCreateLEDTag": "Невозможно создать разрешение LED",
        "CannotCreateVideowallTag": "Невозможно создать холст видеостены",
        "UnknownError": "Произошла неизвестная ошибка. Попробуйте еще раз или обратитесь в службу поддержки.",
        "InvalidAdjustmentsForm": "Ошибки ввода. Заполните все поля правильно.",
        "CanvasDimensionsError": "Ширина или высота холста не генерируются должным образом",
        "playerDeleteConfirmation": "Вы уверены, что хотите удалить плеер: {playerName}?",
        "playerDeleteWarning": "Удаление плеера удалит его из вашего аккаунта SpinetiX HUB и все связанные настройки, включая расписание."
    },
    "planCard": {
        "getPremium": "Получить Premium",
        "bestforGettingStarted": "Лучший для начала",
        "discovery": "Discovery",
        "free": "Бесплатно",
        "oneUser": "1 Пользователь",
        "oneGBStorage": "1 ГБ памяти",
        "nineTemplates": "9 шаблонов",
        "yourPlan": "Ваш план",
        "elevateYourDigitalSignage": "Повысьте качество своих информационных табло",
        "premium": "Premium",
        "premiumPlanPrice": "21 CHF",
        "playerPerMonth": "Плеер / Месяц",
        "tenUsersAndRoles": "10 пользователей",
        "tenGBPlayerStorage": "10 ГБ / Хранилище плеера",
        "twelveTemplatesCustomizable": "12 настраиваемых шаблонов",
        "twelveApps": "12 приложений, включая веб-страницу",
        "elevenApps": "11 приложений",
        "assetGrouping": "Группировка активов",
        "scheduleAutomation": "Автоматизация расписания",
        "priorityScheduling": "Приоритетное планирование",
        "alerts": "Оповещения",
        "audio": "Аудио",
        "videoWallSupport": "Техподдержка видеостен*",
        "new": "Новинка!",
        "withTheNew": "*С новым"
    },
    "planUpgrade": {
        "errorFetchingInvoice": "Ошибка при загрузке счета-фактуры. Попробуйте еще раз.",
        "close": "закрыть",
        "getPremium": "Получить Premium!",
        "companyName": "Название компании",
        "dialogTitle": "Обновление плана",
        "navConfirm": "Подтвердить",
        "navFinish": "Закончить",
        "navNext": "Вперед",
        "navPrev": "Назад",
        "navCancel": "Удалить",
        "VATNumber": "Номер НДС",
        "Overview": "Обзор",
        "AccountOwner": "Владелец учетной записи",
        "CompanyInfo": "Информация о компании",
        "BillingDetails": "Платежная информация",
        "Payment": "Оплата",
        "tryAgain": "ПОВТОРИТЕ ПОПЫТКУ",
        "paymentSuccessful": "Оплата прошла успешно",
        "welcomeToPremium": "Добро пожаловать в Premium!",
        "paymentFailed": "Оплата не прошла.",
        "selectCountry": "Выберите страну",
        "selectState": "Выберите штат"
    },
    "licenseOrdering": {
        "yourOrders": "Ваши заказы",
        "cancelOrder": "Отменить заказ",
        "orderNumber": "Номер заказа",
        "orderDate": "Дата заказа",
        "comment1": "Примечание 1",
        "comment2": "Примечание 2",
        "close": "ЗАКРЫТЬ",
        "cancelOrderWarning": "Вы уверены, что хотите отменить этот заказ?",
        "noOrdersAvailable": "Вы не сделали ни одного заказа",
        "noRecordsFound": "Для запроса \"{query}\" результатов не найдено",
        "noRecordsFoundNote1": "Перепроверьте, нет ли опечаток или ошибок в вашем поиске",
        "noRecordsFoundNote2": "Попробуйте использовать другой поисковый запрос"
    },
    "fileUpload": {
        "notAllowedToUploadMedia": "Пользователю не разрешается выполнять обновление медиафайла.",
        "hashMD5ComputationError": "Что-то пошло не так при вычислении hashMD5.",
        "duplicateFileUploadErrorTitle": "Файл с таким именем уже существует",
        "multipleDuplicateFileUploadErrorTitle": "Файлы с такими именами уже существуют",
        "duplicateFileUploadErrorDescription": "Файл с именем \"{mediaName}\" уже существует в вашей библиотеке.",
        "multipleDuplicateFileUploadErrorDescription": "Файлы с именами \"{mediaNames}\" уже существуют в вашей библиотеке.",
        "duplicateFileUploadErrorMessage": "Проверьте существующий(е) файл(ы) и выберите, что вы хотите сделать с новой загрузкой.\n{pleaseNote}: Если вы замените существующий файл, перезагрузите страницу после завершения загрузки, чтобы увидеть обновлённую версию.",
        "duplicateFileUploadPreviewTitle": "Существующий(е) файл(ы)",
        "pleaseNote": "Обратите внимание"
    },
    "downloadLicense": {
        "confirmDownloadLicense": "Вы уверены? Этот метод предназначен исключительно для плееров, которые не будут подключены к Интернету.",
        "confirmDownloadLicenseWarning": "Использование этого метода немедленно свяжет лицензию с серийным номером без льготного периода для изменений."
    },
    "activation": {
        "assign": "НАЗНАЧИТЬ",
        "yourLicenses": "Ваши лицензии",
        "comment": "Примечание",
        "playerSerialNumber": "Серийный номер плеера",
        "licenseCode": "Лицензионный код",
        "activationDate": "Дата активации",
        "license": "Лицензия",
        "suspend": "Приостановить",
        "restore": "Восстановить",
        "download": "Скачать",
        "licenseAvailable": "Лицензия доступна ",
        "licenseLockedToAPlayer": "Лицензия, закрепленная за плеером",
        "playerSerialNumberRequired": "Введите код серийного номера плеера",
        "licenseCodeRequired": "Введите код лицензии",
        "processing": "Обработка",
        "waitingForPlayerToConnect": "Ожидание подключения плеера",
        "noLicensesAvailable": "Вы не добавили ни одной лицензии"
    },
    "resolutionCalculator": {
        "invalidPitch": "Неверный шаг",
        "invalidSize": "Неверный размер"
    },
    "legal": {
        "legal": "Юридические данные",
        "endUserLicenseAgreement": "ЛИЦЕНЗИОННОЕ СОГЛАШЕНИЕ С КОНЕЧНЫМ ПОЛЬЗОВАТЕЛЕМ",
        "generalTermsAndConditionsOfSale": "ОБЩИЕ ПОЛОЖЕНИЯ И УСЛОВИЯ ПРОДАЖИ",
        "termsOfService": "УСЛОВИЯ ОБСЛУЖИВАНИЯ",
        "privacyPolicy": "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ",
        "cookieNotice": "УВЕДОМЛЕНИЕ О COOKIE",
        "downloadPDF": "СКАЧАТЬ PDF"
    },
    "accountSuspended": {
        "bannerTitle": "Срок действия вашей подписки истек!",
        "bannerMessage": "Если вы хотите продлить срок действия, обратитесь к своему реселлеру."
    },
    "errors": {
        "invalid": {
            "verificationCode": "Указан недействительный код подтверждения, попробуйте снова.",
            "passwordReset": "Пароль не может быть сброшен.",
            "provider": "Недопустимый провайдер. Пожалуйста, попробуйте ещё раз.",
            "emailMismatch": "Введённый адрес электронной почты не совпадает с аккаунтом, на который вы пытаетесь выполнить миграцию."
        },
        "existing": {
            "userAlreadyLinked": "Пользователь уже связан с другим провайдером идентификации (IdP).",
            "accountInAnotherRegion": "У пользователя уже есть аккаунт в другом регионе"
        },
        "failedRefreshToken": "Вы вышли из системы. Пожалуйста, войдите снова, чтобы продолжить.",
        "cannotMigrateAccountInAnotherRegion": "Невозможно выполнить миграцию на SSO, так как ваш адрес электронной почты привязан к другому региону хранения данных, отличному от аккаунта, к которому вы пытаетесь перейти.",
        "nonSSOAuthDenied": "Аутентификация через поставщика без SSO не разрешена.",
        "ssoMigrationFailed": "Доступ запрещён: вы не можете переключиться на SSO, так как ваш аккаунт уже связан с другим провайдером идентификации (IdP). Пожалуйста, обратитесь к администратору за помощью.",
        "loginUnexpectedError": "Вход не выполнен из-за непредвиденной ошибки. Пожалуйста, попробуйте снова.",
        "unexpectedError": "Произошла неожиданная ошибка. Пожалуйста, перезагрузите страницу.",
        "somethingWentWrong": "Похоже, что-то пошло не так ({errorCode})",
        "somethingWentWrongDescription": "При загрузке этой страницы произошла ошибка.<br><br><strong>Что можно сделать:</strong><br>Обновите страницу и попробуйте снова.<br>Если страница по-прежнему не загружается, обратитесь в службу поддержки и укажите ID запроса ниже.",
        "failedToUpdateAccountInfo": "Не удалось обновить информацию учетной записи.",
        "failedToFetchLicenses": "Не удалось получить лицензии.",
        "failedToDownloadLicense": "Не удалось скачать лицензию.",
        "failedToDownloadFile": "Не удалось скачать файл.",
        "failedToFetchUserInfo": "Не удалось получить информацию о пользователе",
        "failedToFetchPlaces": "Не удалось получить список мест",
        "fileNotSupported": "Тип файла не поддерживается."
    },
    "regionNames": {
        "eu": "Европейский Союз / European Union",
        "ch": "Швейцария / Switzerland",
        "us": "Соединенные Штаты / United States",
        "ca": "Канада / Canada",
        "au": "Австралия / Australia",
        "hk": "Гонконг / Hong Kong",
        "sg": "Сингапур / Singapore"
    },
    "zendesk": {
        "chatCouldNotBeLoaded": "Чат не может быть загружен",
        "chatCouldNotBeLoadedDescription": "Мы не смогли загрузить чат поддержки. Обычно это связано с настройками конфиденциальности или файлов cookie в вашем браузере. Для получения инструкций по включению чата поддержки нажмите здесь: {url}."
    },
    "media": {
        "mediaUploadSuccessTitle": "Подготавливаем ваш медиафайл…",
        "mediaUploadSuccessMessage": "Он может не отображаться в текущем представлении из-за активных фильтров или сортировки.",
        "mediaViewLegacyToV2Title": "Обновлённые медиастраницы",
        "mediaViewV2ToLegacyTitle": "Вы используете новый дизайн!",
        "mediaViewSwitcherDescription": "Более быстрая навигация, фильтры и сортировка.",
        "mediaDeleteConfirmation": "Вы уверены, что хотите удалить медиафайл \"{mediaName}\"?",
        "multipleMediaDeleteConfirmation": "Вы уверены, что хотите удалить выбранные медиафайлы ({mediaCount} шт.)?",
        "mediaDeleteWarning": "Удаление этого медиафайла также удалит его из всех проектов.",
        "multipleMediaDeleteWarning": "Удаление этих медиафайлов также удалит их из всех проектов, в которых они используются.",
        "mediaFileUploadInfoMessage": "Если вы их не видите в текущем представлении, они могут быть скрыты активными фильтрами или сортировкой.",
        "mediaIsReady": "Ваши медиа готовы!",
        "mediaIsReadyWithCount": "Ваши медиа готовы! ({count} из {total})",
        "someFilesUploadError": "Некоторые файлы не удалось обработать",
        "failedUploadError": "Ваши файлы не удалось обработать. Попробуйте загрузить их снова.",
        "failedUploadErrorTitle": "Нам не удалось обработать ваши медиа"
    },
    "leaveAccount": {
        "leaveAccountConfirmation": "Вы уверены, что хотите покинуть аккаунт [{accountName}]?",
        "leaveAccountWarning": "Покинув этот аккаунт, вы потеряете доступ к аккаунту и всем связанным продуктам и услугам, доступным вам в настоящее время."
    },
    "led": {
        "deleteCanvasConfirmation": "Вы уверены? Это действие удалит данное разрешение холста со всех плееров.",
        "deleteCanvasWarning": "Любой плеер, который использовал это разрешение холста, потребуется перенастроить до того, как на него снова можно будет публиковать контент с тем же разрешением."
    },
    "popId": {
        "deletePopIdConfirmation": "Вы уверены? Это действие удалит данный PoP ID везде, где он используется."
    },
    "tag": {
        "deleteTagConfirmation": "Вы уверены? Это действие удалит этот тег из всех {source}.",
        "deleteTagWarning": "Это может повлиять на права пользователей и расписание."
    },
    "userProfile": {
        "permanent": "необратимым",
        "deleteUserConfirmation": "Вы собираетесь удалить свой профиль пользователя. Это действие является {permanent} и не может быть отменено.",
        "lose": "потеряете",
        "deleteUserWarning": "Продолжив, вы {lose} доступ ко всем аккаунтам и продуктам, связанным с вашими учётными данными.\nВы уверены, что хотите продолжить?"
    }
}
